import {searchApi, searchData} from "../search-api/search-api";
import {datalayerPush} from "../datalayer-push/datalayer-push";

export const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

const searchForms = document.querySelectorAll<HTMLFormElement>('.f-search');

searchForms.forEach(form => {
  const input = form.querySelector<HTMLInputElement>('.f-text__input');
  const dropdownWrapper = form.querySelector<HTMLElement>('.f-search__dropdown-content');

  let lastFetchedKeyword = null;

  const searchFetch = async (value: string, fullSearch: boolean = false) => {
    if ((value === lastFetchedKeyword) && (fullSearch === false)) {
      return;
    }
    lastFetchedKeyword = value;

    form?.classList.add("--searching");

    const response = form.classList.contains('--herbs')
      ? await searchApi.searchHerbs(value)
      : await searchApi.search(value, fullSearch);

    if (response && response.ok) {
      const data = (await response.json()) as searchData;
      console.log(data);

      if (data.success === false) {
        form.classList.remove("--searching");
        return;
      }

      if (dropdownWrapper) {
        dropdownWrapper.innerHTML = "";
        dropdownWrapper.insertAdjacentHTML("beforeend", data.html);
      }

      if (data.datalayerPush) {
        datalayerPush(data.datalayerPush);
      }

      if (data.requestFullSearch === true) {
        searchFetch(value, true)
      }
    }

    form?.classList.remove("--searching");
  };

  const debouncedFetch = debounce(async (value: string) => searchFetch(value), 300);

  input?.addEventListener('input', () => {
    const currentKeyword = input.value.trim();

    const minKeywordLength = Number(form.dataset.min_keyword_length ?? 3);

    if (currentKeyword.length == minKeywordLength) {
      searchFetch(currentKeyword)
    }

    if (currentKeyword.length >= minKeywordLength) {
      debouncedFetch(currentKeyword);
      form.classList.remove("--first-search");
    } else {
      form.classList.add("--first-search");
    }
  });
});
